import { CCResource, CCShiftType } from '@/api/apis/resources/schedule';

export enum CCShiftOptionType {
  OnCall = CCShiftType.OnCall,
  OnDutyCall = 'OnDutyCall',
  NoCall = CCShiftType.NoCall,
  WeekendOff = CCShiftType.WeekendOff,
  Sick = CCShiftType.Sick,
  Vacation = CCShiftType.Vacation,
  Unavailable = CCShiftType.Unavailable,
}

export type PCCSchedulerControlFilters = {
  isPersonalView: boolean;
  resources: string[];
};

export type PCCOnCallResource = CCResource & {
  isManager: boolean | null;
};
